import React, { forwardRef } from "react";
import { PortfolioItem } from "@/hooks/profile";
import AddPortfolioItemForm from "./AddPortfolioItemForm";

interface EditPortfolioItemFormProps {
  item: PortfolioItem;
  onUpdateItem: (item: PortfolioItem) => void;
  onCancel: () => void;
  userProfession?: string | null;
  userSkills?: string[] | null;
  onSaveStatusChange?: (status: 'idle' | 'saving' | 'saved' | 'error') => void;
}

const EditPortfolioItemForm = forwardRef(({
  item,
  onUpdateItem,
  onCancel,
  userProfession,
  userSkills,
  onSaveStatusChange,
}: EditPortfolioItemFormProps, ref) => (
  <AddPortfolioItemForm
    ref={ref}
    onAddItem={onUpdateItem}
    onCancel={onCancel}
    editingItem={item}
    userProfession={userProfession}
    userSkills={userSkills}
    onSaveStatusChange={onSaveStatusChange}
  />
));

export default EditPortfolioItemForm;
